import apiBase from "../../api/axios";

// ============================================================
// ÁREAS DE DESARROLLO
// ============================================================

export const getAreasDesarrolloService = async (page = 1, search = "") => {
  let url = `v1/talentos-global/areas-desarrollo/?page=${page}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  const response = await apiBase.get(url);
  return response.data;
};

export const getAreaDesarrolloByIdService = async (id) => {
  const response = await apiBase.get(`v1/talentos-global/areas-desarrollo/${id}/`);
  return response.data;
};

export const updateAreaDesarrolloService = async (id, payload) => {
  const response = await apiBase.put(`v1/talentos-global/areas-desarrollo/${id}/`, payload);
  return response.data;
};

export const toggleAreaDesarrolloActiveService = async (id) => {
  const response = await apiBase.post(`v1/talentos-global/areas-desarrollo/${id}/toggle_active/`);
  return response.data;
};

export const getAreasSelectoresService = async (search = "") => {
  let url = "v1/talentos-global/selectores/areas-desarrollo/";
  if (search) url += `?search=${encodeURIComponent(search)}`;
  const response = await apiBase.get(url);
  return response.data;
};

// ============================================================
// ACCIONES DE DESARROLLO
// ============================================================

export const getAccionesDesarrolloService = async ({
  page = 1,
  search = "",
  area = "",
  talento = "",
} = {}) => {
  let url = `v1/talentos-global/acciones-desarrollo/?page=${page}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (area) url += `&area=${area}`;
  if (talento) url += `&talento=${talento}`;
  const response = await apiBase.get(url);
  return response.data;
};

export const getAccionDesarrolloByIdService = async (id) => {
  const response = await apiBase.get(`v1/talentos-global/acciones-desarrollo/${id}/`);
  return response.data;
};

export const createAccionDesarrolloService = async (payload) => {
  const response = await apiBase.post("v1/talentos-global/acciones-desarrollo/", payload);
  return response.data;
};

export const createMultiplesAccionesService = async (payload) => {
  const response = await apiBase.post("v1/talentos-global/acciones-desarrollo/crear-multiples/", payload);
  return response.data;
};

export const updateAccionDesarrolloService = async (id, payload) => {
  const response = await apiBase.put(`v1/talentos-global/acciones-desarrollo/${id}/`, payload);
  return response.data;
};

export const toggleAccionDesarrolloActiveService = async (id) => {
  const response = await apiBase.post(`v1/talentos-global/acciones-desarrollo/${id}/toggle_active/`);
  return response.data;
};

export const getAccionesSelectoresService = async (search = "", area = "") => {
  let url = "v1/talentos-global/selectores/acciones-desarrollo/";
  const params = new URLSearchParams();
  if (search) params.append("search", search);
  if (area) params.append("area", area);
  const queryString = params.toString();
  if (queryString) url += `?${queryString}`;
  const response = await apiBase.get(url);
  return response.data;
};
